import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Toode lisati ostukorvi

  <span style="color:#85c1dc;">**FI:**</span>
  Tuote lisättiin ostoskoriin

  <span style="color:#85c1dc;">**RU:**</span>
  Товар добавлен в корзину
*/
/* @__NO_SIDE_EFFECTS__ */
const m880 = msg(
  mf`Toode lisati ostukorvi`,
  mf`Tuote lisättiin ostoskoriin`,
  mf`Товар добавлен в корзину`,
)

export { m880 as 'w.module.product_modal.product_added' }